var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYanshen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_1816)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 7.03357,
    width: 4.04973,
    height: 0.966454,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.05579,
    y: 7.03357,
    width: 2.92859,
    height: 0.966454,
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.99037,
    y: 7.03357,
    width: 2.92859,
    height: 0.966454,
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.00942,
    height: 15.5136,
    transform: "matrix(0.96881 0.247803 -0.270252 0.96279 14.8007 0.406738)",
    fill: "#00C2FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_1816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYanshen);
export default __webpack_public_path__ + "static/media/yanshen.91e9b83b693df0a148aba43b2adb6754.svg";
export { ForwardRef as ReactComponent };